// frontend/src/pages/WaitEmailConfirmation.js
import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useLang } from '../i18n';

const WaitEmailConfirmation = () => {
  const { t } = useLang();
  const location = useLocation();

  const { email = '', name = '' } = location.state || {};
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper'
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
          {t('auth.waitTitle')}
        </Typography>

      <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
        {name && <strong>{name}! </strong>}
        {t('auth.waitText', { email })}
      </Typography>

        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          {t('auth.waitSpam')}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>

          <Button
            component={RouterLink}
            to="/"
            variant="outlined"
          >
            {t('menu.home')}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default WaitEmailConfirmation;
